<!-- eslint-disable vue/no-v-html -->
<template>
  <article
    class="relative flex h-full flex-col gap-3 rounded-2xl border border-solid border-gray-500 bg-white p-3 transition-shadow hover:shadow-card tablet:rounded-3xl tablet:p-5"
  >
    <h3 class="font-bold leading-7 tablet:text-xl tablet:leading-8">
      <TheNuxtLink
        :to="item.pageUrl"
        :title="item.title"
        class="line-clamp-2 after:absolute after:inset-0"
      >
        <span v-html="provideMarkerText(item.title, keyword)" />
      </TheNuxtLink>
    </h3>
    <p
      v-if="item.description"
      class="line-clamp-3 text-sm leading-5 text-gray-700 tablet:leading-6"
      v-html="provideMarkerText(item.description, keyword)"
    />
    <TheNuxtLink
      v-if="item.hasPricingPlan"
      :to="pricingUrl"
      :title="t('search-menu.pricing')"
      class="relative text-sm font-bold text-blue-400 underline hover:text-blue-500"
    >
      {{ t('search-menu.pricing') }}
    </TheNuxtLink>
  </article>
</template>

<script setup lang="ts">
  import type { ISearchItem } from '@/assets/types/api/Search';

  const props = defineProps<{ item: ISearchItem; keyword: string }>();

  const { t } = useI18n();

  const pricingUrl = computed((): string =>
    props.item.pageUrl.replace('/products/', '/pricing/')
  );
</script>
